// src/components/MaintenanceFormWrapper.jsx
import { Divider, Stack, Button } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import { useMaintenanceForm } from "./useMaintenanceForm";
import MaintenanceCommonForm from "./MaintenanceCommonForm";
import { useTranslation } from "react-i18next";

const MaintenanceFormWrapper = ({ id, onRefresh, type, handleCloseModal }) => {
  const { t } = useTranslation();
  // 사용자가 선택한 id가 전달되어 이 컴포넌트가 렌더링될 때 비로소 훅이 안전하게 실행됩니다.
  const mForm = useMaintenanceForm({ id, onRefresh, type, handleCloseModal });

  return (
    <form onSubmit={mForm.handleSubmit(mForm.onFormSubmit)}>
      
      {/* 100% 동일한 유지보수 공통 폼 양식 */}
      <MaintenanceCommonForm mForm={mForm} />
      
      <Divider sx={{ my: 2 }} />

      {/* 하단 단추 영역 (이 또한 폼 제출과 엮여있으므로 같이 넣어주는 것이 좋습니다) */}
      <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
        <LoadingButton variant="contained" size="small" color="primary" loading={mForm.fileLoading} type="submit">{t('message.common.btn.maintenance.write')}</LoadingButton>
        <Button variant="contained" color="error" size="small" onClick={handleCloseModal}>
            {t('message.common.btn.cancel')}
        </Button>
      </Stack>


      {/* <Stack direction="row" justifyContent="flex-end" spacing={1}>
        {((mForm.type && mForm.type === "modify" && mForm.maintenanceTask?.workingBgnAt) || (!mForm.maintenanceTask?.workingBgnAt)) && (
          <LoadingButton variant="contained" size="small" color="primary" loading={mForm.fileLoading} type="submit">
            {(mForm.type === "modify" && mForm.maintenanceTask?.workingBgnAt) ? "수정" : "등록"}
          </LoadingButton>
        )}
        <Button variant="contained" onClick={handleCloseModal} color="inherit">취소</Button>
      </Stack> */}

    </form>
  );
};

export default MaintenanceFormWrapper;